"use strict";

export { TouchableOpacity, TouchableHighlight, TouchableWithoutFeedback } from 'react-native-gesture-handler';
//# sourceMappingURL=Touchables.js.map